import {INITIAL_ARTICLES_FILTER_PAGINATION} from 'modules/blog/constants';
import {getArticlesByTagController} from 'modules/blog/controller';
import {BlogCategoryPage} from 'modules/blog/pages/BlogCategoryPage';
import {useGetArticlesByTagQuery} from 'modules/blog/services';
import {NextPage} from 'next';
import {useRouter} from 'next/router';
import {useMemo, useState} from 'react';
import {BlogLayoutPage} from 'modules/blog/layouts';
import {withBasicDataServerSide} from 'core/next/controllers';
import {IBreadcrumb} from 'modules/seo/types';

interface IArticlesTagPageProps {
    breadcrumbs?: IBreadcrumb[];
}

const ArticlesTagPage: NextPage<{pageProps: IArticlesTagPageProps}> = ({pageProps: {breadcrumbs = []}}) => {
    const {
        query: {tagPage},
    } = useRouter();

    const [currentPage, setCurrentPage] = useState(1);

    const {data, isLoading} = useGetArticlesByTagQuery({
        tag: tagPage as string,
        ...INITIAL_ARTICLES_FILTER_PAGINATION,
        pageNumber: currentPage,
    });

    const {data: articlesData} = data || {};

    const handleLoadMore = () => {
        setCurrentPage((prev) => prev + 1);
    };

    const isLoadMoreAvailable = useMemo(() => {
        return data && INITIAL_ARTICLES_FILTER_PAGINATION.pageSize
            ? currentPage * INITIAL_ARTICLES_FILTER_PAGINATION.pageSize < Number(data.pagination?.totalCount)
            : false;
    }, [currentPage, data]);

    const title = articlesData?.items[0]?.tags?.find((item) => item.code === tagPage)?.name;

    return (
        <>
            <BlogLayoutPage breadcrumbs={breadcrumbs} title={title}>
                <BlogCategoryPage
                    articles={articlesData?.items}
                    category={'category'}
                    isDataLoading={isLoading}
                    isLoadMoreAvailable={isLoadMoreAvailable}
                    onLoadMore={handleLoadMore}
                    title={title}
                />
            </BlogLayoutPage>
        </>
    );
};

export const getServerSideProps = withBasicDataServerSide(async (store, ctx) => {
    const result = await getArticlesByTagController(store, ctx);

    return {
        props: {
            breadcrumbs: result?.props?.breadcrumbs || [],
        },
    };
});

export default ArticlesTagPage;
